import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OperateursService } from 'src/app/data/intervenant/services/operateurs/operateurs.service';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { switchMap } from 'rxjs/operators';
import { IntervenantVinMini } from '../../../../data/intervenant/models/intervenant-vin-mini.model';
import { LoaderService } from '../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-drev-manquantes',
    templateUrl: './drev-manquantes.component.html',
    styleUrls: ['./drev-manquantes.component.scss'],
    standalone: false
})
export class DrevManquantesComponent implements OnInit {
    /**
     * List of operateurs
     */
    operateurs: IntervenantVinMini[];

    /**
     * Get idOrganisme from session context
     */
    get idOrganisme() {
        return SessionContext.get('idOrganisme');
    }

    constructor(
        private readonly operateursService: OperateursService,
        private readonly loaderService: LoaderService,
        private readonly modalService: NgbModal,
        private readonly router: Router
    ) {}

    /**
     * On init component
     */
    ngOnInit() {
        this.loadData();
    }

    /**
     * Load data
     */
    private loadData(): void {
        this.operateursService
            .getOperateursDREVManquantes(this.idOrganisme)
            .pipe(
                switchMap(drevManquantes => this.operateursService.getIntervenantsVinMini(drevManquantes.intervenantIds)),
                this.loaderService.operator()
            )
            .subscribe(operateurs => {
                this.operateurs = operateurs;
            });
    }

    /**
     * Redirection sur la page Tableau de bord de l'intervenant
     * @param info - Intervenant infos
     */
    onNavigateToDashboardOperateur(info: IntervenantVinMini): void {
        this.router.navigate([`/main/operateurs/or/${info.idIntervenant}/dashboard`]);
    }
}
